import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the sales-orders sub-tree (register at `/sales-invoicing/
 * sales-orders`, create at `/sales-invoicing/sales-orders/new`, detail at
 * `/sales-invoicing/sales-orders/$salesOrderId`) — mirrors `credit-notes.tsx`'s
 * identical 3-route pattern. No chrome of its own; the parent
 * `sales-invoicing.tsx` layout already renders the tab strip. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/sales-orders')({
  component: () => <Outlet />,
});
